import MetalOrderFormPage from "../Pages/MetalOrderFormPage.jsx";
import LoginForm from "./LoginForm.jsx";
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { msalInstance, getGraphProfile, logoutUser } from '../auth';
import companyLogo from "../assets/2.png";
import "./AuthenticatedApp.css";
import { useEffect, useState, useRef } from 'react';


const AuthenticatedApp = ({ onLogout, onLogin, user, useremail }) => {
  const { pathname } = useLocation();
  const isInvite = pathname.startsWith('/invite');

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  
const useIdleLogout = (onTimeout, timeoutMs = 60 * 60 * 1000) => {
    const timerRef = useRef(null);

    const reset = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => onTimeout(), timeoutMs);
    };

}

  useIdleLogout( async () => {
    try {
      await logoutUser();
    } catch {
      onLogout();
    }
  }, 60 * 60 * 1000);

  useEffect(() => {
    let dead = false;
    (async () => {
      try {
        const p = await getGraphProfile();
        if (!dead) setProfile(p);

        console.log("[MSAL] account:", acct);
        console.log("[MSAL] idTokenClaims:", claims);
        console.log("[Graph] /me profile:", p);
      } catch (e) {
        if (!dead) setErr(String(e));
      } finally {
        if (!dead) setLoading(false);
      }
    })();
    return () => {
      dead = true;
    };
  }, []);

  const acct = msalInstance.getAllAccounts()[0] || null;
  const claims = acct?.idTokenClaims || {};


  if (!user) {
    return <LoginForm onLogin={onLogin} />;
  }
  if (!user.username.endsWith("@sidneylee.com")) {
    onLogout();
    return <p>Sign-in restricted to @sidneylee.com accounts only.</p>;
  }
  if (loading) return <p>Loading profile...</p>;
  if (err) return <p>Error loading profile: {err}</p>;

  console.log(JSON.stringify(user.name, null, 2));

  return (
    <div className="app-container">
      {!isInvite && (
        <nav className="app-nav">
          <img src={companyLogo} alt="Company Logo" className="company-logo" />

          <div className="logged-in">
            Logged In As:{" "}
            <span className="logged-in-name">{user.name || user.username}</span>
          </div>

          <button
            onClick={onLogout}
            className="logout-button"
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#b30000")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#d40000")
            }
          >
            LOGOUT
          </button>
        </nav>
      )}


      <Routes>
        <Route path="/" element={<MetalOrderFormPage user={user.name} />} />
      </Routes>
    </div>
  );
};


export default AuthenticatedApp;
